import React from 'react';
import { classNames } from '../../../utils';

type DataTableWrapperType = {
  className?: string;
  children: React.ReactNode;
};

const DataTableWrapper = ({
  className,
  children,
}: DataTableWrapperType): JSX.Element => {
  return (
    <div className={classNames('relative w-full', className && className)}>
      {children}
    </div>
  );
};

export default DataTableWrapper;
